import { ZodTypeDef, z } from "zod";
import { Size, SizeOrUndefined } from "../primitives/size";

export const FigmaFileStructureNodeType = z.enum(["DOCUMENT", "CANVAS", "FRAME", "COMPONENT", "COMPONENT_SET"]);

export const FigmaFileStructureNodeBase = z.object({
  id: z.string(),
  name: z.string(),
  type: FigmaFileStructureNodeType,
  size: SizeOrUndefined,
  parentComponentSetId: z.string().optional(),
});

export const FigmaFileStructureNode: z.ZodType<FigmaFileStructureNode, ZodTypeDef, FigmaFileStructureNodeBaseInput> =
  FigmaFileStructureNodeBase.extend({
    children: z.lazy(() => FigmaFileStructureNode.array()),
  });

type FigmaFileStructureNodeBaseInput = z.input<typeof FigmaFileStructureNodeBase> & {
  children: FigmaFileStructureNodeBaseInput[];
};

export const FigmaFileStructureStatistics = z.object({
  frames: z
    .number()
    .nullable()
    .optional()
    .transform(v => v ?? 0),
  components: z
    .number()
    .nullable()
    .optional()
    .transform(v => v ?? 0),
  componentSets: z
    .number()
    .nullable()
    .optional()
    .transform(v => v ?? 0),
});

export const FigmaFileStructureElementData = z.object({
  value: z.object({
    structure: FigmaFileStructureNode,
    assetsInFile: FigmaFileStructureStatistics,
  }),
});

export type FigmaFileStructureNodeBase = z.infer<typeof FigmaFileStructureNodeBase>;
export type FigmaFileStructureNodeType = z.infer<typeof FigmaFileStructureStatistics>;
export type FigmaFileStructureNode = z.infer<typeof FigmaFileStructureNodeBase> & {
  children: FigmaFileStructureNode[];
};
export type FigmaFileStructureStatistics = z.infer<typeof FigmaFileStructureStatistics>;
export type FigmaFileStructureElementData = z.infer<typeof FigmaFileStructureElementData>;

export function figmaFileStructureToMap(root: FigmaFileStructureNode): Map<string, FigmaFileStructureNode> {
  const map = new Map<string, FigmaFileStructureNode>();
  recursiveFigmaFileStructureToMap(root, map);
  return map;
}

function recursiveFigmaFileStructureToMap(node: FigmaFileStructureNode, map: Map<string, FigmaFileStructureNode>) {
  map.set(node.id, node);
  for (const child of node.children) recursiveFigmaFileStructureToMap(child, map);
}
